<div>
    <ph-skeleton *ngIf="isLoading || fileUploader?.isUploading" lines="3" size="lg"></ph-skeleton>
    <ph-file-upload *ngIf="!isLoading && !fileUploader?.isUploading"
                     accept="application/pdf,image/jpeg,image/png,image/gif,image/heic,image/heif"
                     heading="Drag and drop your invoice here"
                     action="Browse files"
                     [hint]="uploadHint"
                     (ph-files)="onFilesPicked($event)"></ph-file-upload>
</div>
